<template>
  <div class="search-field">
    <v-form class="search-form d-flex align-stretch">
      <v-text-field
        class="flex-grow-1 rounded-l-lg"
        v-model="search"
        placeholder="请输入查询内容"
        hide-details
        type="search"
        :rules="rules"
        counter="50"
        height="35"
        filled
        clearable
        dense
        outlined
        background-color="transparent"
      ></v-text-field>
      <v-btn tile color="primary" height="auto" class="submit rounded-r-lg" >
        <v-icon>mdi-magnify</v-icon>
        查询
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'SearchField',
  props: {},
  data: () => {
    return {
      search: '',
      rules: []
    }
  }
}
</script>

<style lang="scss" scoped>
.search-field {
  .submit {
    margin-bottom: 1px;
    margin-left: -2px;
  }
}
</style>
